export default __webpack_public_path__ + "static/media/ic_arrow_forward.14569ff4.svg";